// extracted by mini-css-extract-plugin
module.exports = {"container":"PageTitleWithBackButton_container__kZBJs","backButton":"PageTitleWithBackButton_backButton__1F0nY","title":"PageTitleWithBackButton_title__1CTMG"};